/* eslint-disable radix */
/* eslint-disable one-var */
/* eslint-disable no-case-declarations */
/* eslint-disable indent */
// 范围日期选择配置
const options = {
  picker: {
    shortcuts: [{
      text: '最近一周',
      onClick (picker) {
        const end = new Date(),
          start = new Date();

        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    },
    {
      text: '最近一个月',
      onClick (picker) {
        const end = new Date(),
          start = new Date();

        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    },
    {
      text: '最近三个月',
      onClick (picker) {
        const end = new Date(),
          start = new Date();

        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        picker.$emit('pick', [start, end]);
      }
    }]
  },
  // 日期格式
  dateFormat: {
    date: 'YYYY-MM-DD',
    dateAndTime: 'YYYY-MM-DD HH:mm:ss',
    dateAndHours: 'YYYY-MM-DD HH:00:00',
    dateAndMinute: 'YYYY-MM-DD HH:mm:00',
    time: 'HH:mm:ss',
    hourMinute: 'HH:mm:00',
    week: 'yyyy 第 WW 周',
    year: 'YYYY',
    yearMonth: 'YYYY-MM',
    month: 'M'
  },

  // 文件上传黑名单
  fileUpBlackList: ['.js', '.vbs', '.exe', '.bat', '.html', '.xml'],
  // 文件上传白名单
  fileUpWhiteList: ['.jpg', '.jpeg', '.png', '.bmp', '.doc', '.docx', '.pdf', '.xls', '.xlsx', '.zip', '.rar', '.7z'],

  // 新增：获取当前时间的方法
  getCurrentTime (formatType = 'dateAndTime') {
    const now = new Date(),
      // 获取日期时间各部分
      year = now.getFullYear(),
      month = String(now.getMonth() + 1).padStart(2, '0'),
      day = String(now.getDate()).padStart(2, '0'),
      hours = String(now.getHours()).padStart(2, '0'),
      minutes = String(now.getMinutes()).padStart(2, '0'),
      seconds = String(now.getSeconds()).padStart(2, '0');

    // 根据formatType返回对应格式
    switch (formatType) {
      case 'date':
        return `${year}-${month}-${day}`;
      case 'dateAndTime':
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      case 'dateAndHours':
        return `${year}-${month}-${day} ${hours}`;
      case 'dateAndMinute':
        return `${year}-${month}-${day} ${hours}:${minutes}`;
      case 'time':
        return `${hours}:${minutes}:${seconds}`;
      case 'hourMinute':
        return `${hours}:${minutes}`;
      case 'week':
        // 计算周数（简化版本）
        const firstDay = new Date(year, 0, 1);
        const pastDays = Math.floor((now - firstDay) / 86400000);
        const weekNumber = Math.ceil((pastDays + firstDay.getDay() + 1) / 7);

        return `${year} 第 ${String(weekNumber).padStart(2, '0')} 周`;
      case 'year':
        return `${year}`;
      case 'yearMonth':
        return `${year}-${month}`;
      case 'month':
        return `${parseInt(month)}`;
      default:
        // 默认返回dateAndTime格式
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
  }

};

export default options;
